import { SET_LOADER, SET_USER_ID, SAVE_SUCCESS } from './typeNames'
import axios from 'axios'
import { baseURL } from './base'
import LZString from 'lz-string'
import { addNewForm } from './formList'
import { browserHistory } from 'react-router'

export const FORM_LIST_VIEW = 'FORM_LIST_VIEW'
export const FORM_SETTINGS_VIEW = 'FORM_SETTINGS_VIEW'
export const LOADER_VIEW = 'LOADER_VIEW'
export const FORM_VIEW = 'FORM_VIEW'
export const QUIZ_SUBMISSION_VIEW = 'QUIZ_SUBMISSION_VIEW'

export const changeView = (view, isRequest) => ({
    type: SET_LOADER,
    view,
    asyncRequest: isRequest
})

export const cancel = (currentView) => dispatch => {
    dispatch(changeView(FORM_LIST_VIEW));    
}

export const setUserId = id => ({
    type: SET_USER_ID,
    id
})

export const save = (settings, design, addForm=false) => dispatch => {
    dispatch(changeView(LOADER_VIEW, true))
    let configObj = {
        design: {
            ...design
        },
        settings:{
            template: settings.template,
            ownerEmail: settings.ownerEmail,
            successMessage: settings.successMessage,
            title: settings.title,
            submitText: settings.submitText,
            elements: [...settings.elements]
        }        
    }

    let form = {...settings.form}
    form.Config = LZString.compressToBase64(JSON.stringify(configObj))
    return axios.put(`${baseURL}/save`, form)
        .then(response => {
            if(response.data.status === 'success'){
                if(form.FormId < 1){
                    form.FormId = response.data.formId
                    dispatch(addNewForm(form))
                    browserHistory.push(`/settings/${response.data.formId}`)
                }else{
                    dispatch(saveSuccess(form)) 
                }               
                if (addForm) {
                    let data = {
                        type: "add_form",
                        id: form.FormId
                    }
                    window.parent.postMessage(JSON.stringify(data), "*")
                }
            }else{
                console.log(response.data); dispatch(() => ({type: "error", err: response.data}))
            }
        })
        .catch(err => {console.log(err); dispatch(() => ({type: "error", err}))})
        .then(() => {console.log("Save Successful!"); dispatch(changeView(FORM_SETTINGS_VIEW, false))})    
}

const saveSuccess = (form) => ({
    type: SAVE_SUCCESS,
    form
})